import navlogo from "../../Assets/Icons/zerozerologo.png";
import React from "react";
import { useState, useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";

import { AiOutlineMobile } from "react-icons/ai";
import { BiLogoFacebook } from "react-icons/bi";

import { BsInstagram } from "react-icons/bs";
import { RiWhatsappLine } from "react-icons/ri";

import { FaHome } from "react-icons/fa";
import { MdEmail } from "react-icons/md";


import { CiYoutube } from "react-icons/ci";
import apiRequest from "../../apiCall";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { setLoading } from "../../Redux/action";
import { useDispatch } from "react-redux";


const validationSchema = Yup.object({
  email: Yup.string()
    .email("Please enter valid email")
    .required("Please Enter Your Email"),
});

export default function Footer() {
  const [showPopup, setShowPopup] = useState(false);
  const [contactUsFooterData, setContactUsFooterData] = useState({});
  const [email, setEmail] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch contact us data when component mounts
    // dispatch(setLoading(true));
    const fetchData = async () => {
      try {
        apiRequest("GET", "contactus", null, false, false).then((res) => {
          setContactUsFooterData(res);
          // dispatch(setLoading(false));
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        // dispatch(setLoading(false));
      }
    };
    
    fetchData();
  }, []);
  

  const handleFormSubmit = (values, { resetForm }) => {
    // Show the popup
    setShowPopup(true);

    // Set the email value
    setEmail(values.email);

    // Reset the form
    resetForm();
  };
  const handleSubmit = async () => {
    try {
      const response = await apiRequest("POST", "newsletter", { email }, null, null);

      if (response === "OK") {
        setShowPopup(false); 
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error occurred while submitting form:", error);
    }
  };
  
  
  return (
    <div>
      <footer className="footer">
        <div className="container">
          <div className="foot-row">
            <div className="footer-col">
              <div className="footer-logo">
                <img src={navlogo} />
              </div>
              <ul>
                <li className="contactfoot">
                  <AiOutlineMobile style={{ paddingRight: "5px" }} />

                  <a href={`tel:${contactUsFooterData.phone}`}>{contactUsFooterData.phone}</a>
                </li>

                <li className="emailfoot">
                  <MdEmail style={{ paddingRight: "5px" }} />
                  <a  href={`mailto:${contactUsFooterData.email}`}>
                  {contactUsFooterData.email}
                  </a>
                </li>
                <li className="whatsapp">
                  <RiWhatsappLine style={{ paddingRight: "5px" }} />
                  <a href={`tel:${contactUsFooterData.whatsapp}`}>{contactUsFooterData.whatsapp}</a>
                </li>
              </ul>

              <div className="social-links">
                <a href="#">
                  <i className="facebook">
                    <BiLogoFacebook />
                  </i>
                </a>

                <a href="#">
                  <i className="youtube">
                    <CiYoutube />
                  </i>
                </a>

                <a href="#">
                  <i className="instagram">
                    <BsInstagram />
                  </i>
                </a>
              </div>
            </div>
            <div className="footer-col">
              <h4 className="footer-title">Useful links</h4>
              <ul className="footer-nav">
                <li>
                  <Link
                    to="/"
                    className={
                      location.pathname === "/" ? "nav-link active" : "nav-link"
                    }
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/shop"
                    className={
                      location.pathname === "/shop"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    Shop
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className={
                      location.pathname === "/about"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    About us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    className={
                      location.pathname === "/blog"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contactus"
                    className={
                      location.pathname === "/contactus"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            {showPopup && (
              <div className="popup">
                <div className="popup-content">
                  <h4>Thank you for subscribing to the ZeroZero News letter</h4>
                  <br />
                  <button onClick={handleSubmit}>Subscribe</button>&nbsp;&nbsp;
                  <button onClick={() => setShowPopup(false)}>Close</button>
                </div>
              </div>
            )}

            <div className="footer-col">
              <h4 className="footer-title">News Letter</h4>
              <Formik
                initialValues={{ email: "" }}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}
              >
                {({ errors, touched, submitCount }) => (
                  <Form>
                    {submitCount > 0 && errors.email && touched.email && (
                      <div className="erroremail">{errors.email}</div>
                    )}
                    <br />
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email address"
                    />
                    <br />
                    <button type="submit">Submit</button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <hr />
          <center className="copyright">
            © 2023 ZEROZERO. All Rights Reserved{" "}
          </center>
        </div>
      </footer>
    </div>
  );
}
